/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const IndonesiaKeepsakes = lazy(() => import('./pages/IndonesiaKeepsakes'))
const IndonesiaNLIHP = lazy(() => import('./pages/IndonesiaNLIHP'))

export default [
  <SiteRoute key="nlihp" exact path="/" component={IndonesiaNLIHP} />,
  <SiteRoute key="keepsakes" path="/keepsakes" component={IndonesiaKeepsakes} />,
]
